import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-Jwt',
    templateUrl: './Jwt.component.html'
})
export class JwtComponent implements OnInit {

    consumerID: string;
    uri_param_names = 'jwt';
    claims_to_verify: string;
    key_claim_name: string;
    secret_is_base64 = false;
    anonymous: string;
    run_on_preflight = true;
    cookie_names: [];
    maximum_expiration = 0;

    data = {
        'consumerID' : this.consumerID,
        'uri_param_names' : this.uri_param_names,
        'claims_to_verify' : this.claims_to_verify,
        'key_claim_name' : this.key_claim_name,
        'secret_is_base64' : this.secret_is_base64,
        'anonymous' : this.anonymous,
        'run_on_preflight' : this.run_on_preflight,
        'cookie_names' : this.cookie_names,
        'maximum_expiration' : this.maximum_expiration,
        'plugin' : 'jwt'
    }
    constructor() { }

    slider1() {
        this.secret_is_base64 = !this.secret_is_base64;
    }
    // slider2() {
    //     this.hideCredentials = !this.hideCredentials;
    // }

    slider3() {
        this.run_on_preflight = !this.run_on_preflight;
    }

    JwtAuth() {
    }

    ngOnInit() {
    }

}
